import * as React from 'react'
import ListMoney from '../listMoney'
import ContactForm from '../contactForm'
import Message from '../message'
import TaxForm from '../taxForm'

const optionPro = [
    {
        name: 'Test 1',
        value: '1'
    },
    {
        name: 'Test 2',
        value: '3'
    },
]



class Sections extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            prefer: [
                {
                    donate: '',
                    program: '',
                }
            ],
        }
    }

    getValue = (value,index) =>{
        let prefers = this.state.prefer;
        prefers[index]['donate'] = value
        this.setState({prefer: prefers})
    }

    handleAddPrefer = (event) => {
        const THIS = event.target
        let prefers = this.state.prefer;
        prefers.push({
            donate: '',
            program: '',
        })
        this.setState({prefer: prefers})
    }


    handleRemovePrefer = (event) => {
        const THIS = event.target
    }



    render() {
        let { data } = this.props;
        let count = optionPro.length;
        const renderSection = data.data.data.map((item, index) => {
            let { title, description, list_money } = item
            return (
                <div key={`ecf-form-donate-${index}`} className="ecf-form-donate__item">
                    <div className="ecf-form-donate__item-divide">
                        <div className="ecf-form-donate__item-col">
                            <div className="ecf-form-donate__item-col-contain">
                                <div className="ecf-form-donate__item-title">
                                    {title}
                                </div>
                                <div
                                    className="ecf-form-donate__item-description"
                                    dangerouslySetInnerHTML={{ __html: description }}
                                />
                            </div>
                        </div>
                        <div className="ecf-form-donate__item-col">
                            {list_money.length > 0 && (
                                <ListMoney
                                    getValue={this.getValue}
                                    moneys={list_money}
                                    options={optionPro}
                                    handleAddPrefer={this.handleAddPrefer}
                                    prefer={this.state.prefer}
                                />
                            )}
                            {index == 1 &&
                                <ContactForm />
                            }
                            {index == 2 &&
                                <TaxForm />
                            }
                            {index == 3 &&
                                <Message />
                            }
                        </div>
                    </div>
                </div>
            )
        })
        return (
            <>
                <div className="ecf-form-donate__list">
                    {renderSection}
                </div>
                <div className="ecf-form-donate__policy">
                    <div
                        className="ecf-form-donate__policy-box ecf-wp-editor"
                        dangerouslySetInnerHTML={{ __html: data.data.option.policy }}
                    />
                    <div className="ecf-form-donate__policy-check-box">
                        <input
                            name="agreeReceve"
                            type="checkbox"
                            id="agreeReceve"
                            value="yes"
                        // checked={this.state.isGoing}
                        // onChange={this.handleInputChange} 
                        />
                        <label htmlFor="agreeReceve" >
                            <span>
                                I agree to receive other communications from ECF.
                            </span>
                        </label>
                    </div>
                    <div className="ecf-form-donate__policy-button">
                        <button
                            className="ecf-btn ecf-btn-primary"
                            aria-label="donate-submit-button"
                        >
                            {data.data.option.button}
                        </button>
                    </div>
                </div>
            </>
        )
    }
}

export default Sections;